export default "__VITE_ASSET__B5t_CnmQ__"